module.exports = __webpack_public_path__ + "img/platform.c3cbd8ce.jpg";